/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Ronnel Bedana - ronnel@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { CrmAlertComponent } from 'src/app/components/fields';
import { Report, SideNote } from 'src/app/model';
import { ReportProvider, SideNoteProvider } from 'src/app/providers';
import { SystemType } from 'src/app/model/enums/system.type';

@Component({
  selector: 'assign-report-modal',
  templateUrl: './assign-report.modal.html',
  styleUrls: ['./assign-report.modal.scss']
})
export class AssignReportModal implements OnInit, OnDestroy {
  @ViewChild('alert') alert: CrmAlertComponent;
  subject: Subject<Report>;
  subscription: any;
  selectedReport: Report;
  report: Report;
  note: SideNote

  currentMode: SystemType;
  modeSub: any;

  constructor(
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    public reportProvider: ReportProvider,
    private sideNoteProvider: SideNoteProvider
  ) { }

  ngOnInit(): void {
    // Fix for when user clicks `ESC` instead of clicking, no Event was firing
    this.subscription = this.modalService.onHide.subscribe((reason: string) => {
      if (reason === 'esc') {
        this.onCancel();
      }
    });
  }

  ngOnDestroy(): void {
    if(this.modeSub)
      this.modeSub.unsubscribe();
  }

  onSelected(value: any): void {
    this.selectedReport = value != null ? value.VALUE : null;
  }

  onConfirm(): void {
    this.alert.hide();

    this.sideNoteProvider.save(this.note.ID, 'REPORT', this.selectedReport.ID)
      .subscribe(data => {
        if (data.success) {
          this.bsModalRef.hide();
          this.subject.next(this.selectedReport);
          this.subject.complete();
        }
        else {
          this.alert.show(data.error);
        }
      });
  }

  onCancel(): void {
    this.bsModalRef.hide();
    this.subject.next(null);
    this.subject.complete();
  }
}
